// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gysbyC0aB0NeBS {
  display: flex;
  position: fixed;
  z-index: -900;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--ds-background-neutral, #091e420f);
}
.GLW1fADJJC1vef,
.pycisJMzPSnwlP {
  position: absolute;
  z-index: -999;
  bottom: var(--ds-space-0, 0);
  width: 400px;
  max-width: 30%;
}
@media only screen and (max-width: 750px) {
  .GLW1fADJJC1vef,
  .pycisJMzPSnwlP {
    display: none;
  }
}
.GLW1fADJJC1vef {
  left: var(--ds-space-0, 0);
}
.pycisJMzPSnwlP {
  right: var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `gysbyC0aB0NeBS`,
	"left": `GLW1fADJJC1vef`,
	"right": `pycisJMzPSnwlP`
};
export default ___CSS_LOADER_EXPORT___;
